module.exports = __webpack_public_path__ + "assets/img/znjj_d_s_3.2ed66f93.png";